export const crimson = {
  1: { value: { base: '{colors.crimson.light.1}', _dark: '{colors.crimson.dark.1}' } },
  2: { value: { base: '{colors.crimson.light.2}', _dark: '{colors.crimson.dark.2}' } },
  3: { value: { base: '{colors.crimson.light.3}', _dark: '{colors.crimson.dark.3}' } },
  4: { value: { base: '{colors.crimson.light.4}', _dark: '{colors.crimson.dark.4}' } },
  5: { value: { base: '{colors.crimson.light.5}', _dark: '{colors.crimson.dark.5}' } },
  6: { value: { base: '{colors.crimson.light.6}', _dark: '{colors.crimson.dark.6}' } },
  7: { value: { base: '{colors.crimson.light.7}', _dark: '{colors.crimson.dark.7}' } },
  8: { value: { base: '{colors.crimson.light.8}', _dark: '{colors.crimson.dark.8}' } },
  9: { value: { base: '{colors.crimson.light.9}', _dark: '{colors.crimson.dark.9}' } },
  10: { value: { base: '{colors.crimson.light.10}', _dark: '{colors.crimson.dark.10}' } },
  11: { value: { base: '{colors.crimson.light.11}', _dark: '{colors.crimson.dark.11}' } },
  12: { value: { base: '{colors.crimson.light.12}', _dark: '{colors.crimson.dark.12}' } },
  a1: { value: { base: '{colors.crimson.light.a1}', _dark: '{colors.crimson.dark.a1}' } },
  a2: { value: { base: '{colors.crimson.light.a2}', _dark: '{colors.crimson.dark.a2}' } },
  a3: { value: { base: '{colors.crimson.light.a3}', _dark: '{colors.crimson.dark.a3}' } },
  a4: { value: { base: '{colors.crimson.light.a4}', _dark: '{colors.crimson.dark.a4}' } },
  a5: { value: { base: '{colors.crimson.light.a5}', _dark: '{colors.crimson.dark.a5}' } },
  a6: { value: { base: '{colors.crimson.light.a6}', _dark: '{colors.crimson.dark.a6}' } },
  a7: { value: { base: '{colors.crimson.light.a7}', _dark: '{colors.crimson.dark.a7}' } },
  a8: { value: { base: '{colors.crimson.light.a8}', _dark: '{colors.crimson.dark.a8}' } },
  a9: { value: { base: '{colors.crimson.light.a9}', _dark: '{colors.crimson.dark.a9}' } },
  a10: { value: { base: '{colors.crimson.light.a10}', _dark: '{colors.crimson.dark.a10}' } },
  a11: { value: { base: '{colors.crimson.light.a11}', _dark: '{colors.crimson.dark.a11}' } },
  a12: { value: { base: '{colors.crimson.light.a12}', _dark: '{colors.crimson.dark.a12}' } },
}
